import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { AlertService } from '../../shared/services/alert.service';
import { TranslateService } from '@ngx-translate/core';

export const subscriptionErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const alertService = inject(AlertService);
  const translate = inject(TranslateService);

  return next(req).pipe(
    tap({
      error: (error) => {
        if (error.status === 429) {
          alertService.warning(translate.instant('subscription.limits.orderLimit'));
          return;
        }

        if (error.status === 403 && error.error) {
          const message = typeof error.error === 'string' ? error.error : error.error.message || '';
          const msg = message.toLowerCase();

          if (msg.includes('staff limit')) {
            alertService.warning(translate.instant('subscription.limits.staffLimit'));
          } else if (msg.includes('restaurant limit')) {
            alertService.warning(translate.instant('subscription.limits.restaurantLimit'));
          } else if (msg.includes('delivery')) {
            alertService.warning(translate.instant('subscription.limits.deliveryLimit'));
          } else if (msg.includes('insights')) {
            alertService.warning(translate.instant('subscription.limits.insightsLimit'));
          } else if (msg.includes('promo')) {
            alertService.warning(translate.instant('subscription.limits.promoLimit'));
          }
        }
      },
    })
  );
};
